import React, { useState, useEffect, useRef } from "react";
import Spinner from "../../utils/spinner/Spinner";
import { toast } from "react-toastify";
import { useSymbolContext } from "../../../contexts/Symbol-Context.js";
import {
  API_ENDPOINT_ORDER_DETAIL,
  API_ENDPOINT_POSITION_DETAIL,
  API_ENDPOINT_UPDATE_ORDER_DETAIL,
  API_ENDPOINT_UPDATE_POSITION_DETAIL,
} from "../../../data/Endpoints-API.js";
import APIMiddleware from "../../../data/api/Api-Middleware.js";
import { useAuthContext } from "../../../contexts/Auth-Context.js";
import { formatPrice, formatFixedTrimmed } from "../../../utils/format.js";
import SLTP from "../market_order/SLTP.jsx";
import { useTranslation } from "react-i18next";

interface EditSltpProps {
  onCancel: () => void;
  editPositionId: any;
  currentPrice: any;
  isOrder?: boolean;
}

const EditSltp: React.FC<EditSltpProps> = ({
  onCancel,
  editPositionId,
  currentPrice,
  isOrder = false,
}) => {
  const { t } = useTranslation();
  //CONTEXT
  const { loadingSymbolContext, symbolData,setIsPositionEdited } = useSymbolContext();
  const { user,selectedAuthSymbol ,platFromData, isFirstLoginDisabled} = useAuthContext();
   let platFormData = null;
  if(isOrder){
    platFormData = platFromData[4]?.openedOrders?.find((item:any) => item.order_id == editPositionId)
  }else{
    platFormData = platFromData[3]?.openedPositions?.find((item:any) => item.id == editPositionId)
  }

  const selectedPositionData = platFormData;
   const entryPrice = selectedPositionData?.entry_price;
  // #region All states defined here States
  const [direction, setDirection] = useState("Buy");
  const [tradeQuantity, setTradeQuantity] = useState(0.0);
  const [tradeEntryPrice, setTradeEntryPrice] = useState(() => {
    const ep = selectedPositionData?.entry_price;
    if (ep == null || ep === "") return "";
    const n = Number(ep);
    return Number.isFinite(n) && n > 0 ? formatFixedTrimmed(n, 10) : "";
  });
  const [takeProfit, setTakeProfit] = useState(0.0);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [stopLoss, setStopLoss] = useState(0.0);
  const [selectedSymbol, setSelectedSymbol] = useState({ask:0.0, bid:0.0, ea:1, eb:1})
  const [selectedPosition, setSelectedPosition] = useState({
    SL: null,
    TP: null,
    position_id: "",
    direction: "",
    entry_price: "",
    symbol: "",
  });
  const [slPips, setSlPips] = useState(0.0);

  //dragable dialogbox 
  const cardRef = useRef<HTMLDivElement>(null);
  const [position, setPosition] = useState({x:0 , y:0});
  const [isDragging, setIsDragging] = useState(false);
  const [dragOffset, setDragOffset] = useState({x:0, y:0});

  const handleMouseDown = (e)=>{
    if (e.button !== 0) return;
    e.preventDefault();
    setIsDragging(true)
    setDragOffset({
      x: e.clientX - position.x,
      y: e.clientY - position.y,
    })
  }

  const handleMouseMove = (e)=>{
    if(isDragging){
      const rect = cardRef.current?.getBoundingClientRect();
      if (!rect) return;
      const left = rect.left - position.x, top = rect.top - position.y;
      setPosition({
        x: Math.min(Math.max(e.clientX - dragOffset.x, 8 - left), window.innerWidth - rect.width - 8 - left),
        y: Math.min(Math.max(e.clientY - dragOffset.y, 8 - top), window.innerHeight - rect.height - 8 - top),
      });
    }
  }

  const handleMouseUp = ()=>{
    setIsDragging(false)
  }

  useEffect(() => {
    const clamp = () => {
      const rect = cardRef.current?.getBoundingClientRect();
      if (!rect) return;
      const dx = rect.left < 8 ? 8 - rect.left : rect.right > window.innerWidth - 8 ? window.innerWidth - 8 - rect.right : 0;
      const dy = rect.top < 8 ? 8 - rect.top : rect.bottom > window.innerHeight - 8 ? window.innerHeight - 8 - rect.bottom : 0;
      if (dx || dy) setPosition(previous => ({ x: previous.x + dx, y: previous.y + dy }));
    };
    window.addEventListener('resize', clamp);
    const stop = () => setIsDragging(false);
    window.addEventListener('mouseup', stop);
    window.addEventListener('blur', stop);
    const observer = new ResizeObserver(clamp);
    if (cardRef.current) observer.observe(cardRef.current);
    return () => { observer.disconnect(); window.removeEventListener('resize', clamp); window.removeEventListener('mouseup', stop); window.removeEventListener('blur', stop); };
  }, [loadingSymbolContext]);

  const handleDisabledButton = (data) => {
    setIsButtonDisabled(data)
  };

  const [tpPips, setTpPips] = useState(0.0);
  // SL: null, TP: null, position_id: '', direction: '', entry_price: ''

  // #endregion

  const posSymbol =
    selectedPositionData?.symbol ||
    selectedPosition?.symbol ||
    selectedAuthSymbol;
  const tick = posSymbol ? symbolData?.[posSymbol] : null;
  const posDirection = String(
    selectedPositionData?.direction || direction || "Buy"
  );
  // Validation mark: Buy → bid, Sell → ask (same as open-position / strategy rules)
  const liveMark = (() => {
    if (isOrder) return 0;
    const bid = Number(tick?.bid);
    const ask = Number(tick?.ask);
    const fromTick = posDirection === "Sell" ? ask : bid;
    if (Number.isFinite(fromTick) && fromTick > 0) return fromTick;
    const fromPos = Number(selectedPositionData?.current_price);
    return Number.isFinite(fromPos) && fromPos > 0 ? fromPos : 0;
  })();
  const sltpSecondPrice = isOrder
    ? tradeEntryPrice
    : liveMark > 0
      ? formatFixedTrimmed(liveMark, 10)
      : tradeEntryPrice;

 

  // #region All UseEffect defined here States

  useEffect(() => {
    if (editPositionId) {
      updateSelectedPosition(editPositionId);
    }
  }, [editPositionId]);

  // #region All functions defined here States
  useEffect(() => { 
    setSelectedSymbol(symbolData[selectedPosition?.symbol])
  }, [editPositionId, selectedPosition?.symbol])
  
  useEffect(() => {
    setTradeEntryPrice(
      entryPrice != null && entryPrice !== ""
        ? formatFixedTrimmed(Number(entryPrice), 10)
        : ""
    );
  }, [entryPrice]);
  const handleProfitChange = (data) => {
    setTakeProfit(data);
  };
  const handleLossChange = (data) => {
    setStopLoss(data);
  };
  const handleSLPipsChange = (data) => {
    setSlPips(data)
  };


  const handleTPPipsChange = (data) => {
    setTpPips(data)
  };

  const updateSelectedPosition = async (p_id) => {
    try {
      if (user && user.userId !== undefined && user.userId > 0) {
        const response = await APIMiddleware.get( isOrder ? API_ENDPOINT_ORDER_DETAIL(user.userId, p_id) :
          API_ENDPOINT_POSITION_DETAIL(user.userId, p_id)
        );
        if (response.data) {
          const positionDetails = response.data[0];
          setSelectedPosition(positionDetails);
          setDirection(positionDetails.direction);
          setTradeQuantity(positionDetails.quantity);
        }
      }
    } catch (error) {
      // Handle API request error
      console.error(
        `API request error: ${API_ENDPOINT_POSITION_DETAIL}`,
        error
      );
    }
  };
 
  const onSubmit = async () => {
    try {
      if (isOrder) {
        const entry = parseFloat(tradeEntryPrice);
        if (
          tradeEntryPrice === "" ||
          tradeEntryPrice == null ||
          isNaN(entry) ||
          entry <= 0
        ) {
          toast.error(t('editSltp.validEntryPrice'), {
            position: "top-right",
          });
          return;
        }
      }

      setIsLoading(true);
      const payload = {
        userId: user.userId,
        SL: stopLoss,
        TP: takeProfit,
        symbol: selectedPosition.symbol,
        quantity: tradeQuantity,
        entry_price: tradeEntryPrice,
        direction: direction,
        stop_loss_pips: slPips,
        take_profit_pips: tpPips,
        ...(isOrder
          ? { orderId: selectedPosition.order_id }
          : { positionId: selectedPosition.position_id }),
      };
      if (user && user.userId !== undefined && user.userId > 0) {
        const response = await APIMiddleware.post( isOrder ? API_ENDPOINT_UPDATE_ORDER_DETAIL():
          API_ENDPOINT_UPDATE_POSITION_DETAIL(),
          payload
        );

        if (response.data) {
          setTakeProfit(0.0);
          setStopLoss(0.0);
          toast.success(response.data[0].message, { position: "top-right" });
          setIsPositionEdited(Math.floor(Math.random()*100))
          onCancel();
        }
      }
    } catch (error) {
      const apiMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.response?.data?.data?.error ||
        t('editSltp.updateError');
      toast.error(apiMessage, { position: "top-right" });
      // Handle API request error
      console.error(
        `API request error: ${API_ENDPOINT_POSITION_DETAIL}`,
        error
      );
    } finally {
      setIsLoading(false);
    }
  };
  //show spinner while loading data
  if (loadingSymbolContext) {
    return <Spinner />;
  }
  
  return (
    <div className="dialog-modal edit-sltp-dialog" onMouseUp={handleMouseUp} onMouseMove={handleMouseMove}>
      <div ref={cardRef} className="card" style={{transform:`translate(${position.x}px, ${position.y}px)`,
      position: `absolute`, }}>
        <div className="model-header" onMouseDown={handleMouseDown}>
          {isOrder ? <h2>{t('editSltp.modifyOrder', { id: selectedPosition?.order_id })}</h2> :
          <h2>{t('editSltp.modifyPosition', { id: selectedPosition?.position_id ? selectedPosition.position_id.toString().padStart(8, "0") : "---" })}</h2> }

        </div>
        <div className="model-details">
          <p>{t('editSltp.symbol')}</p> <h2>{selectedPosition?.symbol}</h2>
          <p>{t('editSltp.currentPrice')}</p> <h2> {formatPrice(selectedPositionData?.current_price)}</h2>
        </div>
        {isOrder &&
        <div className="model-details model-details-entry">
          <p>{t('editSltp.entryPrice')}</p>
          <input
            type="text"
            inputMode="decimal"
            value={tradeEntryPrice ?? ""}
            maxLength={32}
            onChange={(e)=>{
              const val = e.target.value;
              if (val.length > 32) return;
              // Allow empty / in-progress decimals like "0."; max 10 digits after decimal
              if (val === "" || /^\d*\.?\d{0,10}$/.test(val)) {
                setTradeEntryPrice(val);
              }
            }}
            onBlur={() => {
              const entry = parseFloat(tradeEntryPrice);
              if (tradeEntryPrice !== "" && tradeEntryPrice != null && !isNaN(entry) && entry > 0) {
                setTradeEntryPrice(formatFixedTrimmed(entry, 10));
              }
            }}
          />
        </div>
  }
            
        <div className="model-sltp-container">
          <SLTP
            isPendingOrder={isOrder}
            isEditPosition={!isOrder}
            handleDisabledButton={handleDisabledButton}
            handleSLPipsChange={handleSLPipsChange}
            handleTPPipsChange={handleTPPipsChange}
            handleProfitChange={handleProfitChange}
            handleLossChange={handleLossChange}
            editPositionId={editPositionId}
           entryPrice={tradeEntryPrice}
          secondPrice={sltpSecondPrice}
          onCancel={onCancel}
          />
        </div>

        <div className="row-scss">
          <button
            onClick={() => {
              onCancel();
            }}
          >
            {t('common.cancel')}
          </button>
          <button
            title={
              
                // (platFromData[5]?.riskLocked || platFromData[5]?.accessRight == 3)
                // ? "Trading for this Account in Disabled"
                // :platFromData[5]?.accessRight == 2
                //   ? "The status of this account is set to Close Only . You can only close your existing Positions" 
                //   :
                   ""
            }   
          disabled={isFirstLoginDisabled || (platFromData[5]?.riskLocked || platFromData[5]?.accessRight == 3)|| localStorage.getItem('accountType') =="0"|| platFromData[5]?.accessRight == 2|| isButtonDisabled || isLoading}
            onClick={() => {
              onSubmit(); 
            }}
          >
            {!isLoading ? t('editSltp.submit') : t('editSltp.loading')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditSltp;
